import { Button } from "@mui/material";
import React from "react";

export default function ButtonSubmit({ children, ...props }) {
  return (
    <Button
      type="submit"
      variant="contained"
      sx={{
        marginTop: "6px",
        paddingInline:"100px",
        boxShadow: "none",
        borderRadius: "0.8rem",
        textTransform: "initial",
        fontWeight: "bold",
        fontSize: "1rem",
        paddingTop: "8px",
        paddingBottom: "8px"
      }}
      color="blueOcean"
      {...props}
    >
      {children}
    </Button>
  );
}
